import { baseApi } from "./baseApi";

export const organizationEndpoint = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    switchClient: builder.mutation({
      query: (clientCode: string) => ({
        url: `auth/switch-client/${clientCode}`,
        method: "POST",
      }),
    }),
    getClients: builder.query({
      query: () => ({
        url: `/organisation/`,
        method: "GET",
      }),
    }),
    setUpDefaultClient: builder.mutation({
      query: (clientCode: string) => ({
        url: `auth/change-default-client/${clientCode}`,
        method: "POST",
      }),
    }),
    getUserDetails: builder.query({
      query: (userId: string) => ({
        url: `/get-users-details/${userId}`,
        method: "GET",
      }),
    }),
    getUsersByOrganization: builder.query({
      query: (orgCode: string) => ({
        url: `/users/get-users-by-organisation/${orgCode}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useSwitchClientMutation,
  useGetClientsQuery,
  useSetUpDefaultClientMutation,
  useGetUserDetailsQuery,
  useGetUsersByOrganizationQuery,
} = organizationEndpoint;
